module.exports = __webpack_public_path__ + "img/ada.b845547f.png";